import { MouseEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Stepper as BaseStepper, Step, Grid, Fade } from '@mui/material'
import { Step as StepType } from 'shared/types'
import { Header, Button, StepLabel } from './FormStepper.style'

interface FormStepperProps {
  isLoading?: boolean
  steps?: StepType[]
}

const FormStepper = ({ steps = [], isLoading }: FormStepperProps) => {
  const { t } = useTranslation()
  const [activeStep, setActiveStep] = useState(0)
  const isLastStep = activeStep === steps.length - 1
  const onNextClick = (e: MouseEvent<HTMLButtonElement>) => {
    if (!isLastStep) {
      e.preventDefault()
      setActiveStep(activeStep + 1)
    }
  }
  const onPrevClick = () => activeStep > 0 && setActiveStep(activeStep - 1)

  return (
    <>
      <Grid container>
        <Header item xs={9}>
          <BaseStepper
            activeStep={activeStep}
            sx={{
              '& .MuiStepConnector-root': {
                flex: 0,
              },
            }}
          >
            {steps.map(({ label }) => (
              <Step expanded key={`stepper-item-${label}`} sx={{}}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </BaseStepper>
        </Header>
      </Grid>
      {steps.length && steps[activeStep].component}
      <Grid container justifyContent="flex-end">
        <Fade in={activeStep > 0}>
          <Button
            fullWidth={false}
            color="primary"
            variant="outlined"
            onClick={onPrevClick}
            sx={{
              marginBottom: { xs: 1, sm: 0 },
            }}
          >
            {t('prev')}
          </Button>
        </Fade>
        <Button
          fullWidth={false}
          color="primary"
          variant="contained"
          loading={isLoading}
          onClick={onNextClick}
          disabled={steps[activeStep].isNextDisabled}
          type={isLastStep ? 'submit' : 'button'}
          sx={{
            marginBottom: { xs: 1, sm: 0 },
          }}
        >
          {t(isLastStep ? 'create' : 'next')}
        </Button>
      </Grid>
    </>
  )
}

export default FormStepper
